import { render, staticRenderFns } from "./MyTemplates.vue?vue&type=template&id=a4643d6c"
import script from "./MyTemplates.vue?vue&type=script&lang=js"
export * from "./MyTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports